<script>
export default {
  name: "ColumnHelpModal",
  props: { colType: String },
  data() {
    return {
      helpTypes: [
        {
          type: "unpl",
          title: "수익",
        },
        {
          type: "profit",
          title: "매도 설정",
        },
        {
          type: "stop",
          title: "매수 중지",
        },
        {
          type: "force",
          title: "강제 매도",
        },
      ],
    };
  },
  computed: {
    currentHelpInfo: function () {
      return this.helpTypes.find((f) => f.type === this.colType);
    },
  },
};
</script>
<template>
  <div class="common-modal-wrap">
    <div class="pc-modal-content">
      <div class="pc-modal-header">
        <h4 class="text-lg font-bold">{{ currentHelpInfo.title }}</h4>
        <button @click="$emit('modal-close')" class="text-gray-500">
          닫기
        </button>
      </div>
      <div class="p-4 text-left">
        <div v-if="currentHelpInfo.type === 'unpl'">
          <!-- 수익 계산 공식 설명  -->
          <p class="helpTitle">수익 계산 공식</p>
          <ul>
            <li class="mb-4">
              <label class="helpLabel"
                >1. UNPL 계산 공식 <small>(바이낸스 발췌)</small></label
              >
              <p class="helpFormula">
                Size * direction * (markPrice - entryPrice)
              </p>
              <p class="helpSummary">
                - Size : 레버리지가 포함된 해당 심볼 수량
              </p>
              <p class="helpSummary">
                - direction : 포지션 (long = 1 , short = -1)
              </p>
              <p class="helpSummary">- markPrice : 현재가</p>
              <p class="helpSummary">- entryPrice : 포지션 진입 가격(평단가)</p>
            </li>
            <li>
              <label class="helpLabel"
                >2. ROI 계산 공식 <small>(바이낸스 발췌)</small></label
              >
              <p class="helpFormula">
                Size * direction * (markPrice - entryPrice) / initialMagin * 100
              </p>
              <p class="helpSummary">
                - Size : 레버리지가 포함된 해당 심볼 수량
              </p>
              <p class="helpSummary">
                - direction : 포지션 (long = 1 , short = -1)
              </p>
              <p class="helpSummary">- markPrice : 현재가</p>
              <p class="helpSummary">- entryPrice : 포지션 진입 가격(평단가)</p>
              <p class="helpSummary">- initialMargin : 투입 순 자산</p>
            </li>
          </ul>
          <div></div>
        </div>
        <div v-if="currentHelpInfo.type === 'profit'">
          <p class="helpTitle">매도 설정 트리거 조건</p>
          <ul>
            <li class="mb-2">
              <label class="helpLabel"
                >해당 매도(수익실현)는
                <b class="text-red-400">평단가</b>기준으로 계산됩니다</label
              >
            </li>
            <li>
              <label class="helpLabel">1. LONG 포지션 </label>
              <p class="helpFormula">평균단가 * (1 + 수익실현% / 레버리지)</p>
            </li>
            <li>
              <label class="helpLabel">2. SHORT 포지션 </label>
              <p class="helpFormula">평균단가 * (1 - 수익실현% / 레버리지)</p>
            </li>
          </ul>
        </div>
        <div v-if="currentHelpInfo.type === 'stop'">
          <p class="helpTitle">매수 중지 트리거 조건</p>
          <ul>
            <li class="mb-2">
              <label class="helpLabel"
                >해당 매수 중지(물타기 중지)는
                <b class="text-red-400">평단가</b>기준으로 계산됩니다</label
              >
            </li>
            <li>
              <label class="helpLabel">1. LONG 포지션 </label>
              <p class="helpFormula">평단가 * (1 - 매수 중지(%) / 레버리지)</p>
            </li>
            <li>
              <label class="helpLabel">2. SHORT 포지션 </label>
              <p class="helpFormula">평단가 * (1 + 매수 중지(%) / 레버리지)</p>
            </li>
          </ul>
        </div>
        <div v-if="currentHelpInfo.type === 'force'">
          <p class="helpTitle">매도 설정 트리거 조건</p>
          <ul>
            <li class="mb-2">
              <label class="helpLabel"
                >해당 강제 매도(포지션 청산)는
                <b class="text-red-400">평단가</b>기준으로 계산됩니다</label
              >
            </li>
            <li>
              <label class="helpLabel">1. LONG 포지션 </label>
              <p class="helpFormula">평균단가 * (1 - 강제매도% / 레버리지)</p>
            </li>
            <li>
              <label class="helpLabel">2. SHORT 포지션 </label>
              <p class="helpFormula">평균단가 * (1 + 강제매도% / 레버리지)</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
